import { getUser } from "./auth"
const isBrowser = () => typeof window !== "undefined"

const setUID = () => {
  if(!isBrowser()) return;
  if(typeof window.gtag !== 'function') return;
  const uid = getUser();
  if(!uid) return;
  window.gtag('config', process.env.GATSBY_MEASUREMENT_ID, {
    'user_id': uid,
  });
  window.gtag('set', 'user_properties', {
    'crm_id' : uid,
  });
}

const addPaymentInfo = ({ paymentType, itemId, itemName, price }) => {
  if(!isBrowser()) return;
  if(typeof window.gtag !== 'function') return;
  window.gtag("event", "add_payment_type", {
    currency: "USD",
    value: price,
    payment_type: paymentType,
    items: [
      {
        item_id: itemId,
        item_name: itemName,
        currency: "USD",
        price,
        quantity: 1,
      }
    ]
  });
}

const beginCheckout = ({ itemId, itemName, price }) => {
  if(!isBrowser()) return;
  if(typeof window.gtag !== 'function') return;
  window.gtag("event", "begin_checkout", {
    currency: "USD",
    value: price,
    items: [
      {
        item_id: itemId,
        item_name: itemName,
        currency: "USD",
        price,
        quantity: 1,
      }
    ]
  });
}

const pageLocation = ({ location }) => {
  if(!isBrowser()) return;
  if(typeof window.gtag !== 'function') return;
  window.gtag("set", "page_location", pageLocation)
}

const pageTitle = ({ title }) => {
  if(!isBrowser()) return;
  if(typeof window.gtag !== 'function') return;
  window.gtag("set", "page_title", title)
}

const purchase = ({ transactionId, itemId, itemName, price }) => {
  if(!isBrowser()) return;
  if(typeof window.gtag !== 'function') return;
  window.gtag("event", "purchase", {
    transaction_id: transactionId,
    currency: "USD",
    value: price,
    items: [
      {
        item_id: itemId,
        item_name: itemName,
        currency: "USD",
        price,
        quantity: 1,
      }
    ]
  });
}

const searchTerm = ({ search_term }) => {
  if(!isBrowser()) return;
  if(typeof window.gtag !== 'function') return;
  window.gtag("event", "search", { search_term });
}

const selectContent = ({ itemId, contentType }) => {
  if(!isBrowser()) return;
  if(typeof window.gtag !== 'function') return;
  window.gtag("event", "select_content", {
    content_type: contentType.replace(/-/g, '_'),
    item_id: itemId,
  });
}

const selectItem = ({ itemId, itemName, price }) => {
  if(!isBrowser()) return;
  if(typeof window.gtag !== 'function') return;
  window.gtag("event", "select_item", {
    items: [
      {
        item_id: itemId,
        item_name: itemName,
        price,
        quantity: 1
      }
    ]
  });
}

const exception = ({ error_description, fatal }) => {
  if(!isBrowser()) return;
  if(typeof window.gtag !== 'function') return;
  window.gtag("event", "exception", {
    items: [
      {
        error_description,
        fatal,
      }
    ]
  });
}

export {
  addPaymentInfo,
  beginCheckout,
  exception,
  pageLocation,
  pageTitle,
  purchase,
  searchTerm,
  selectContent,
  selectItem,
  setUID,
}
